/* eslint-disable */
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import {
  closeInvite,
  selectIsInviteActive,
} from '../../../../redux/slicers/camera/renderPreviewPoppupSlicer';
import { ModalArea } from '../../../../common/ModalButtonArea';
import { icons } from '../../../../assets';
import TagInputField from '../../../../common/TagInputField';
import { Form } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { apiGetPermissionsList, apiSendInvite } from '../../../../helpers/api';
import { BigButton } from '../../../../common';
import { ROLE_ORG_INTERNAL_USER } from '../../../../constants/constants';
import { successToast } from '../../../../helpers/toastHelper';
import { sendInvitedUserToHubspot } from '../../../../helpers/apiHelper';
import { useUserContext } from '../../../../contexts/UserContext';
const { WarningIcon } = icons;

export const InviteModal = () => {
  const dispatch = useDispatch();
  const isActive = useSelector(selectIsInviteActive);

  if (!isActive) return null;

  return (
    <ModalArea
      showModal={Boolean(isActive)}
      setShowModal={() => dispatch(closeInvite())}
      title="Invite your friends"
      size="lg"
      centered={true}
      animation
      body={
        <>
          <InviteUser />
        </>
      }
    />
  );
};

const initialErrorState = {
  emails: '',
  permissionsList: '',
};

const InviteUser = () => {
  const { currentUser } = useUserContext();
  const dispatch = useDispatch();
  const [emails, setEmails] = useState([]);
  const [errors, setErrors] = useState(initialErrorState);
  const [loading, setLoading] = useState(false);
  const [defaultPermissions, setDefaultPermissions] = useState([]);

  useEffect(async () => {
    const res = await apiGetPermissionsList('pre_fix=lf_invite_internal&default_permission=true');
    if (!res) return;
    const permissionIds = res.results
      .filter((a) => a?.owner_can_manage === true)
      .map((item) => item.id);
    setDefaultPermissions(permissionIds);
  }, []);

  const resetStates = () => {
    setLoading(false);
    setErrors(initialErrorState);
    setEmails([]);
  };

  const handleInviteUser = () => {
    console.log('handleInviteUser', emails, defaultPermissions);
    setLoading(true);
    const formData = new FormData();
    formData.append('role', ROLE_ORG_INTERNAL_USER);
    emails.forEach((email) => formData.append('send_to', email.name));
    defaultPermissions.forEach((permission) => formData.append('permission', permission));

    sendInvitedUserToHubspot({
      name: currentUser?.user?.name,
      firstname: currentUser?.user?.first_name,
      lastname: currentUser?.user?.last_name,
      email: currentUser?.user?.email,
      company: currentUser?.organization_detail?.name,
      invited_users: emails.map((a) => a.name)?.join(','),
    });

    apiSendInvite(formData)
      .then((res) => {
        if (res?.status) {
          successToast('Users invited successfully');
          dispatch(closeInvite());
        }
      })
      .finally(() => resetStates());
  };

  return (
    <InviteViaEmailUI
      emails={emails}
      errors={errors}
      setEmails={setEmails}
      setErrors={setErrors}
      onSubmit={handleInviteUser}
      loading={loading}
      buttonTitle={'Invite'}
    />
  );
};

export const InviteViaEmailUI = ({
  emails,
  errors,
  setEmails,
  setErrors,
  onSubmit,
  loading,
  btnFullWidth = true,
  buttonTitle = 'Submit',
  buttonClassName,
  buttonStyle = {},
  labelColor = '#5a5c61',
  customTagsStyle = {},
}) => {
  const [mounted, setMounted] = useState(false);
  const isBtnDisabled = emails.length === 0 || loading;

  useEffect(() => {
    setMounted(true);
  }, []);

  const validateForm = () => {
    let eflag = true;
    if (emails.length === 0) {
      eflag = false;
      setErrors((prevState) => ({ ...prevState, emails: 'This field should not be empty' }));
    } else {
      const res = emails.find((email) => email.warning === true);
      if (res) {
        eflag = false;
      } else {
        eflag = true;
      }
      setErrors((prevState) => ({ ...prevState, emails: !eflag ? 'Invalid email' : '' }));
    }
    return eflag;
  };

  useEffect(() => {
    if (!mounted) return;
    validateForm();
  }, [emails]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    onSubmit?.();
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group>
        {errors.emails ? (
          <Form.Label className="text-danger" style={{ fontSize: 14 }}>
            <WarningIcon /> {errors.emails}
          </Form.Label>
        ) : (
          <Form.Label style={{ color: labelColor, fontSize: 14 }}>
            Email<span className="ms-1">*</span>
          </Form.Label>
        )}
        <TagInputField
          setData={setEmails}
          className={errors.emails ? 'input-error' : ''}
          validateForm={validateForm}
          setErrors={setErrors}
          customStyle={customTagsStyle}
        />
        <BigButton
          type="submit"
          disabled={isBtnDisabled}
          className={cx('bigButton lf-btn-1 mt-4', btnFullWidth ? 'w-100' : '', buttonClassName)}
          buttonTitle={buttonTitle}
          isLoading={loading}
          style={buttonStyle}
        />
      </Form.Group>
    </Form>
  );
};
